import Service, { ServiceDto } from '../Service';
import Services from '../Services';
import Shopify from './Shopify';
import Squarespace from './Squarespace';
import Wix from './Wix';

export default class Webhooks extends Services<Service> {
  protected unserialize(dto: ServiceDto): Service {
    switch (dto.provider) {
      case 'shopify': {
        return new Shopify(dto, this.save);
      }
      case 'squarespace': {
        return new Squarespace(dto, this.save);
      }
      case 'wix': {
        return new Wix(dto, this.save);
      }
      default: {
        throw new Error(`Unknown webhook provider ${dto.provider}`);
      }
    }
  }
}
